import e from"./is-object.js";import a from"./classof-raw.js";import l from"./well-known-symbol.js";var m=e,n=a,s=l,f=s("match"),t=function(r){var o;return m(r)&&((o=r[f])!==void 0?!!o:n(r)=="RegExp")};export{t as default};
